import { render, staticRenderFns } from "./CaptionText.vue?vue&type=template&id=03de6cfa&scoped=true&"
import script from "./CaptionText.vue?vue&type=script&lang=js&"
export * from "./CaptionText.vue?vue&type=script&lang=js&"
import style0 from "./CaptionText.vue?vue&type=style&index=0&id=03de6cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03de6cfa",
  null
  
)

export default component.exports